// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f2434ef","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};